export default __webpack_public_path__ + "2598fbf297c9ff5059c9aa304c8a766c.png";